module.exports = __webpack_public_path__ + "img/feature2.780814a.png";